import * as THREE from 'three'
import Model from './Model'
import Part from './Part'
import Variant from './Variant'
import Island from './Island'
import Stage from 'components/Designer/Stage'
import quiltType from 'components/Designer/MaterialEditor/Quilt/quiltType'

class Section extends THREE.Group {
  uuid: string
  component: string
  model: Model
  part: Part
  variant: Variant
  islands: THREE.Group
  // NOTE: pure Islands, actual objects instead of 3DObjects because
  // this.islands.children returns only 3DObjects
  pIslands: Island[]
  constructor({
    uuid,
    model,
    part,
    variant,
    datatype,
    islands,
    structure,
  }: {
    uuid: string
    model: Model
    part: Part
    variant: Variant
    datatype: string
    islands: any
    structure: any
  }) {
    super()
    this.uuid = uuid
    this.component = 'section'
    this.model = model
    this.part = part
    this.variant = variant
    this.islands = new THREE.Group()
    this.pIslands = []

    if (datatype !== 'section') {
      console.error(
        `There is an issues with the data provided` +
          `@model:${model.uuid}` +
          `@part:${uuid}` +
          `@variant${variant.uuid}` +
          `@section:${uuid}`
      )
    }

    for (let islandKey of structure) {
      const island_uuid = islandKey
      const island_data = islands[islandKey]
      const parmObject = {
        uuid: island_uuid,
        model,
        part,
        variant,
        section: this,
        datatype: 'island',
        data: island_data,
      }
      const island = new Island({ ...parmObject })
      this.islands.add(island)
      this.pIslands.push(island)
    }

    // if (Math.random() > 0.6) {
    //   Stage.outlinePass.selectedObjects.push(this.islands)
    // }

    this.add(this.islands)
    Stage.selectableSections.push(this)
  }
}

export default Section
